import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
// Importuojame cache valdiklį
import cacheManager from './utils/CacheManager';
// Importuojame tab storage cleanup
import { cleanupOldTabStorage } from './utils/tabStorage';

// Inicializuojame cache valdymą
cacheManager.initialize();

// Išvalome senus tab storage įrašus
cleanupOldTabStorage();

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  // <React.StrictMode>
    <App />
  // </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
